import { Component, Input } from '@angular/core';
import { AnnouncementInterface } from '@careapp/angular-sdk';

@Component({
  selector: 'ca-announcements',
  templateUrl: 'announcements.component.html',
  styleUrls: ['announcements.component.scss']
})
export class AnnouncementsComponent {
  @Input() announcements: AnnouncementInterface[];
}
